import { AttributesStore } from '../../store/AttributesStore';
import { cssNamespace } from '../../config';
import CssTemplate from "../../../../.tmp/styles/main.css";
import {
  getVerticalParameters,
  getHorizontalParameters,
  getTemplate,
  hasContrast,
  isWhite,
  mapPosition
} from './CustomStyle.utils';

const initStyle = `${cssNamespace}{display:none;} ${cssNamespace} .fab-desktop, ${cssNamespace} .frame{visibility: hidden}`;

// HTMLStyleElement <style>;
let element;

export const CustomStyle = {
  initialize: initialize,
  activate: activate
};

function initialize() {
  const style = document.createElement("style");
  style.textContent = initStyle;
  document.head.appendChild(style);
}

function activate() {
  AttributesStore.subscribe(onStyleChanged);

  document.head.appendChild(element = document.createElement("style"));

  return element;
}

// interface IStyleParams {
//     color: string;
//     offsetX: number;
//     offsetY: number;
//     position: number;
//     styleTemplate: string;
// }

/**
 * Inject overriding style to html page
 *
 * @param {Object} model - attributes from store
 */
function onStyleChanged(model) {
  const style = {};

  style.styleTemplate = model.styleTemplate;
  style.mediaMobileWidth = model.mediaMobileWidth;

  style.color = model.color || '#15b79a';

  const offsetX = model.offsetX;
  style.offsetX = offsetX || (offsetX === 0 ? 0 : 15);

  const offsetY = model.offsetY;
  style.offsetY = offsetY || (offsetY === 0 ? 0 : 15);

  const position = model.position;
  // default position is: 2 - bottom right
  style.position = mapPosition(position);


  setTimeout(() => {
    element.innerHTML = prepareCss(style, CssTemplate);
  }, 0);
}

/**
 * Compute css that will be used to override base style
 *
 * @param {IStyleParams} style - style object with general props from backend
 * @param {string} cssTemplate - css template used to generate overriding style
 */
function prepareCss(style, cssTemplate) {
  let template = getTemplate(style.styleTemplate),
    horizontalPosition = getHorizontalParameters(style.position),
    verticalPosition = getVerticalParameters(style.position),
    frameWidth = template.frameWidth,
    frameHeight = template.frameHeight,
    fabHeight = 60,
    fabFullHeight = fabHeight + 15,
    //approximately fab tooltip width + fab widh
    fabActionButtonsMinWidth = 130 + 60,
    //can be higher when more channels are added
    fabActionButtonsMinHeight = 180,
    isContrast = hasContrast('#ffffff', style.color),
    ufwMainColor = style.color,
    ufwLightTextColor = isContrast ? '#ffffff' : '#1E1E1E',
    ufwTooltipOutline = isWhite(style.color) ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0)',
    ufwWhiteIconColor = isWhite(style.color) ? '#1E1E1E' : style.color,
    ufwFrameWidth = frameWidth + 'px',
    ufwFrameHeight = frameHeight + 'px',
    ufwFrameMobileWidth = frameWidth - 2 + 'px',
    ufwFrameMobileHeight = template.frameHeightMobile - 1 + 'px',
    //no-offset margins - 15 or smaller if smaller offset is specified in general data
    fabMarginX = (+style.offsetX) > 15 ? 15 : (+style.offsetX),
    fabMarginY = (+style.offsetY) > 15 ? 15 : (+style.offsetY),
    //minimum size for fab and actions buttons open view
    fabButtonsMinWidth = `${fabActionButtonsMinWidth + fabMarginX + (+style.offsetX)}px`,
    fabButtonsMinHeight = `${fabActionButtonsMinHeight + fabFullHeight + fabMarginY + (+style.offsetY)}px`,
    //ufw prefix - variables injected to custom style template
    //frame position normal view
    ufwFrameOffsetX = `${+style.offsetX}px`,
    ufwFrameOffsetY = `${fabFullHeight + (+style.offsetY)}px`,
    //fab position normal view
    ufwFabOffsetX = `${+style.offsetX}px`,
    ufwFabOffsetY = `${+style.offsetY}px`,
    //no-offset view media queries
    ufwMediaNoOffsetWidth = `${frameWidth + fabMarginX + (+style.offsetX)}px`,
    ufwMediaNoOffsetHeight = `${frameHeight + fabFullHeight + fabMarginY + (+style.offsetY)}px`,
    //no-offset view
    ufwFabNoOffsetX = `${fabMarginX}px`,
    ufwFabNoOffsetY = style.offsetY > 15 ? '15px' : `${+style.offsetY}px`,
    ufwFrameNoOffsetY = style.offsetY > 15 ? '90px' : `${fabFullHeight + (+style.offsetY)}px`,
    //no-offset view with small desktop
    ufwSmallDesktopHeight = frameHeight + fabFullHeight + 2 * fabMarginY + 'px',
    ufwFrameSmallDesktopY = fabFullHeight + 2 * fabMarginY + 'px',
    //mobile view media queries
    ufwMediaMobileWidth = (style.mediaMobileWidth || fabMarginX + frameWidth - 1) + 'px',
    ufwMediaMobileHeight = fabMarginY + fabFullHeight + template.frameHeightMobile + 'px',
    //mobile view
    ufwFabTranslateY = `${fabHeight + (+style.offsetY)}`; //hide fab

  return cssTemplate
    .replace(/_horizontal_main/g, horizontalPosition.main)
    .replace(/_horizontal_second/g, horizontalPosition.second)
    .replace(/_horizontal_flex_start/g, horizontalPosition.flex_start)
    .replace(/_horizontal_flex_end/g, horizontalPosition.flex_end)
    .replace(/_vertical_main/g, verticalPosition.main)
    .replace(/_vertical_second/g, verticalPosition.second)
    .replace(/_vertical_translate_(.?)([0-9]{0,3})(.{0,2})_/g, verticalPosition.multiply())
    .replace(/_horizontal_translate_(.?)([0-9]{0,3})(.{0,2})_/g, horizontalPosition.multiply())
    .replace(/_vertical_rotate/g, verticalPosition.rotate)
    .replace(/ufwMainColor/g, ufwMainColor)
    .replace(/ufwLightTextColor/g, ufwLightTextColor)
    .replace(/ufwFrameWidth/g, ufwFrameWidth)
    .replace(/ufwFrameHeight/g, ufwFrameHeight)
    .replace(/ufwTooltipOutline/g, ufwTooltipOutline)
    .replace(/ufwWhiteIconColor/g, ufwWhiteIconColor)
    .replace(/ufwFrameOffsetX/g, ufwFrameOffsetX)
    .replace(/ufwFrameOffsetY/g, ufwFrameOffsetY)
    .replace(/fabButtonsMinWidth/g, fabButtonsMinWidth)
    .replace(/fabButtonsMinHeight/g, fabButtonsMinHeight)
    .replace(/ufwMediaNoOffsetWidth/g, ufwMediaNoOffsetWidth)
    .replace(/ufwMediaNoOffsetHeight/g, ufwMediaNoOffsetHeight)
    .replace(/ufwFabOffsetX/g, ufwFabOffsetX)
    .replace(/ufwFabOffsetY/g, ufwFabOffsetY)
    .replace(/ufwSmallDesktopHeight/g, ufwSmallDesktopHeight)
    .replace(/ufwFrameSmallDesktopY/g, ufwFrameSmallDesktopY)
    .replace(/ufwFabNoOffsetX/g, ufwFabNoOffsetX)
    .replace(/ufwFabNoOffsetY/g, ufwFabNoOffsetY)
    .replace(/ufwFrameNoOffsetY/g, ufwFrameNoOffsetY)
    .replace(/ufwFrameMobileWidth/g, ufwFrameMobileWidth)
    .replace(/ufwFrameMobileHeight/g, ufwFrameMobileHeight)
    .replace(/ufwMediaMobileWidth/g, ufwMediaMobileWidth)
    .replace(/ufwMediaMobileHeight/g, ufwMediaMobileHeight)
    .replace(/_vertical_translate_(.?)(ufwFabTranslateY)(.{0,2})_/g, verticalPosition.multiply(ufwFabTranslateY));
}

